import React, {useEffect, useState} from "react";
import * as Notifications from "src/core/notifications";
import useRouter from "src/core/common/hooks/useRouter";
import SetPasswordWithTokenModal from "src/core/authentication/components/SetPasswordWithTokenModal";
import useRecoverPassword from "src/core/authentication/hooks/useRecoverPassword";

export default function ResetPasswordWithTokenModal({closeModal}) {
  const router = useRouter();

  const [state, api] = useRecoverPassword();
  const [submitted, setSubmitted] = useState(false);
  const {data, error} = state;

  const {token} = router.query;

  useEffect(() => {
    if (submitted && (data || error)) {
      setSubmitted(false);
      !error && Notifications.success("Reset password successful.");
      !error && closeModal();
    }
  }, [error, data, submitted, closeModal]);

  function onSubmit(formValues) {
    setSubmitted(true);

    api.resetPassword({
      token,
      password: formValues.password,
      phoneNumber: formValues.phoneNumber,
    });
  }

  return (
    <SetPasswordWithTokenModal
      title={"Reset password"}
      onSubmit={onSubmit}
      closeModal={closeModal}
      loading={state.loading}
      buttonText={"Reset Password"}
      helpText={"Enter a new password"}
    />
  );
}
